export default [
  { prop: 'data.venue', header: 'Venue' },
  { prop: 'data.address', header: 'Address' },
  { prop: 'data.likes', header: 'Likes' },
  { prop: 'data.rating', header: 'Rating' },
  { prop: 'data.raters', header: 'Raters' },
]
